import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox } from '@els/els-react--checkbox';

import './SelectedItemsControls.custom.scss';
import './SelectedItemsControls.theme.scss';

export default function SelectedItemsControls(props) {
  const { checkAllItems, allItemsSelected, someItemsSelected, currentSelectedItems } = props;

  return (
    <div className="selected-items-controls-wrapper">
      <Checkbox
        size="sm"
        title="Select all"
        wrapperToggleProps={{
          strokeWidth: 20,
        }}
        className="selected-items-controls-checkbox e2e-allResults"
        onChange={() => {
          checkAllItems(!allItemsSelected);
        }}
        checked={allItemsSelected}
        toggleWrapperClassName="selected-items-controls-toggle-wrapper-checkbox"
        labelClassName="selected-items-controls-toggle-label"
        indeterminate={someItemsSelected}
        ariaControlsGuidance={`${currentSelectedItems} items selected`}
      />
      <span className="selected-items-controls-label">
        <span className="selected-items-controls-label-count">{currentSelectedItems}</span>
        <span className="selected-items-controls-label-text hide-below-desktop ">selected</span>
      </span>
    </div>
  );
}

SelectedItemsControls.propTypes = {
  checkAllItems: PropTypes.func.isRequired,
  allItemsSelected: PropTypes.bool.isRequired,
  someItemsSelected: PropTypes.bool,
  currentSelectedItems: PropTypes.number.isRequired,
};
